<div class="preview-container p-16">
    <div class="preview-ticket-info">
        <span class="cm-icon cm-icon-bar-code"></span>
    </div>
    <hr>
    <div class="preview-image">
        <span class="cm-icon cm-icon-image"></span>
    </div>
</div>
